// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RememberLast$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/RememberLast.res.mjs";
import * as StoryverseLevelupData$LiteracyplanetClientSxEntry from "./StoryverseLevelupData.res.mjs";
import * as StoryverseUnlockQuery$LiteracyplanetClientSxEntry from "./StoryverseUnlockQuery.res.mjs";
import * as StoryverseLevelupQuery$LiteracyplanetClientSxEntry from "./StoryverseLevelupQuery.res.mjs";
import * as StoryverseLevelupMutation$LiteracyplanetClientSxEntry from "./StoryverseLevelupMutation.res.mjs";

var S = {
  useLevelupQuery: StoryverseLevelupQuery$LiteracyplanetClientSxEntry.use,
  useInsertLevelup: StoryverseLevelupMutation$LiteracyplanetClientSxEntry.use,
  useLocalStorage: RememberLast$LiteracyplanetClientFlags.useValue,
  useUnlocksQuery: StoryverseUnlockQuery$LiteracyplanetClientSxEntry.use
};

var include = StoryverseLevelupData$LiteracyplanetClientSxEntry.Make(S);

var useLevelupMutation = include.useLevelupMutation;

var usePreviousPoints = include.usePreviousPoints;

var useHasLocationChanged = include.useHasLocationChanged;

var useUnlockType = include.useUnlockType;

var useCobraProps = include.useCobraProps;

var use = include.use;

export {
  S ,
  useLevelupMutation ,
  usePreviousPoints ,
  useHasLocationChanged ,
  useUnlockType ,
  useCobraProps ,
  use ,
}
/* include Not a pure module */
